function o(n){return n.split(".").length>2?n.split(".").slice(1).join("."):n}export{o as domainFromSubdomain};
//# sourceMappingURL=domain-from-subdomain.js.map
